import { render, staticRenderFns } from "./team-members.vue?vue&type=template&id=cb933846&scoped=true&"
import script from "./team-members.vue?vue&type=script&lang=js&"
export * from "./team-members.vue?vue&type=script&lang=js&"
import style0 from "./team-members.vue?vue&type=style&index=0&id=cb933846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb933846",
  null
  
)

export default component.exports